export const TRANSLATIONS_FR = {};